import { atom } from 'jotai'
import { IAccountBuyer } from '../types'

type IAccountBuyersState = Array<IAccountBuyer> | null

const defaultState: IAccountBuyersState = null

// base atom with initial value
export const accountBuyersAtom = atom<IAccountBuyersState>(defaultState)